import { apiClient, unwrap } from '@/lib/apiClient';
import type { NotificationSource } from '@/features/notifications/api/notifications.api';
import type { ApiSuccess } from '@/types/api';
import type { NotificationInbox } from '@/types/notification';

/**
 * The student's own inbox, for the bell in the student panel.
 *
 * The same shape as the staff and parent inboxes, under `/student` — a child
 * never reaches the institute routes. No path names a recipient: the server
 * reads the account from the token.
 */
export const studentNotificationsApi: NotificationSource = {
  inbox: () => unwrap(apiClient.get<ApiSuccess<NotificationInbox>>('/student/notifications')),

  markRead: (uuid: string) =>
    unwrap(apiClient.patch<ApiSuccess<null>>(`/student/notifications/${uuid}/read`)),

  markAllRead: () =>
    unwrap(apiClient.post<ApiSuccess<{ count: number }>>('/student/notifications/read-all')),
};
